import script from "./DeleteOrganizationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteOrganizationModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteOrganizationModal.vue?vue&type=style&index=0&id=7ce6961d&scoped=true&lang=css"
script.__scopeId = "data-v-7ce6961d"

export default script